@if (loading()) {
  <div class="loading-container">
    <oph-loading [diameter]="24" [strokeWidth]="2"></oph-loading>
  </div>
} @else {
  <button class="icon-button" [class.has-icon]="icon()" (click)="openIconPicker()">
    @if (icon()) {
      <img [src]="'assets/img/icons/color-icons/' + icon() + '.svg'" class="task-icon" />
    } @else {
      <span class="add-icon-text">ADD<br />ICON</span>
    }
  </button>
}
